var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"product-evaluate"},_vm._l((_vm.goods_evaluation),function(item){return _c('div',{key:item.id,staticClass:"product-evaluate-item"},[_c('h3',[_vm._v(_vm._s(item.user_name))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(item.evaluation))])])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47c88d7b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/system-com/product-evaluate.vue
// module id = null
// module chunks = 